/**
 * @file SafeLoadIcon.tsx
 * @description The SafeLoad app icon, rendered like an app icon (rounded corners)
 * @module components/shared
 */

interface SafeLoadIconProps {
  /** Rendered width and height in CSS pixels */
  size?: number;
}

/**
 * The SafeLoad icon as delivered for the app stores (LCA-157). The source PNG
 * has square corners because Apple masks icons at display time, so the
 * rounding is applied here, at the same ratio as the mark it replaced
 * (rx 10 on a 40 box).
 */
export function SafeLoadIcon({ size = 32 }: SafeLoadIconProps) {
  return (
    <img
      src="/safeload-icon.png"
      alt="SafeLoad"
      width={size}
      height={size}
      style={{ borderRadius: size / 4, display: 'block', flexShrink: 0 }}
    />
  );
}
